var lib_core = require("lib-core");
var DualRowPackageData = require('./dualRowPackageData.js');

var DfnPackageWithIdenticalPadsData = function(position, angle, init) {
    DualRowPackageData.apply(this, arguments);

    this.horizontalPinPitch = this.value("horizontalPinPitch", true);

    //component family if any
    this.componentFamily = this.value("componentFamily", true);

    this.nonTransformedSegmentedGeometry.addTrigger(this.horizontalPinPitch);
    this.nonTransformedSegmentedGeometry.addTrigger(this.componentFamily);
};

lib_core.inherit(DfnPackageWithIdenticalPadsData, DualRowPackageData);
lib_core.JsonParser.registerClass(DfnPackageWithIdenticalPadsData, "DfnPackageWithIdenticalPadsData");

DfnPackageWithIdenticalPadsData.prototype.setupMinMaxPtrMap = function() {
    DualRowPackageData.prototype.setupMinMaxPtrMap.call(this);
    this.validationMap["horizontalPinPitch"] = [this.horizontalPinPitch];
};

module.exports = DfnPackageWithIdenticalPadsData;

